import {Component} from '@angular/core';
import {AbstractStudyComponent} from "../../../abstract-study.component";
import {CompetitiveIntelligenceStudy} from "../../competitive-intelligence-study";
import {ActivatedRoute} from "@angular/router";
import {map} from "rxjs/operators";
import {StudiesNames} from "../../../studies-names";
import {CategoryName} from "../../../category-name";

@Component({
    selector: 'kiwi-dish-sales-prices-comparison',
    templateUrl: './dish-sales-prices-comparison.component.html',
    styleUrls: ['./dish-sales-prices-comparison.component.scss'],
    host: { 'class': 'cell auto grid-y' },
    standalone: false
})
export class DishSalesPricesComparisonComponent extends AbstractStudyComponent<CompetitiveIntelligenceStudy> {

    constructor(route: ActivatedRoute) {
        super(CategoryName.COMPETITIVE_INTELLIGENCE,
            route.paramMap.pipe(
                map(paramMap => {
                    return StudiesNames.SALES_PRICES_COMPARISON + '/' + paramMap.get('dishName')
                })
            ));
    }
}
